export default __webpack_public_path__ + "static/media/122.fd6d28ed.svg";